import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import _ from "lodash";

import { Translate, I18n } from "react-redux-i18n";

import Spinner from "react-bootstrap/Spinner";

import { setAlert } from "../../../actions/alertActions";
import {
  getPlug,
  getPlugStatus,
  getModeByChargerType,
  roundToDecimals,
  calculateEstimatedCost,
  lottieModule,
  momentModule,
} from "../../utils/Utils";

import CostInfoModal from "../../utils/components/CostInfoModal";

import "../../../styles/components/map/chargerInfo/PlugPicker.scss";
import info from "../../../styles/images/info.svg";

const { moment, formatDate } = momentModule;

const { lottie } = lottieModule;
let cancelToken = null;

class PlugPicker extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.elContainer = null;

    this.state = {
      isAnimationRunning: false,

      plugs: [],
      selectedPlug: null,
      tariff: null,

      estimateTime: 30,
      costPer30: null,
      cost: null,
      cpoTariffsPrices: null,

      date: new Date(),

      modals: {
        info: false,
      },
    };

    this.calculateMaxTimeEstimate = this.calculateMaxTimeEstimate.bind(this);
    this.handlePlugClick = this.handlePlugClick.bind(this);
    this.handleSliderChange = this.handleSliderChange.bind(this);
    this.handleOnCharge = this.handleOnCharge.bind(this);
    this.fetchMobieTariffs = this.fetchMobieTariffs.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.safeSetState(
      {
        plugs: this.props.charger.properties.plugs,
        selectedPlug:
          this.props.charger.properties.plugs.length > 0
            ? this.props.charger.properties.plugs[0]
            : null,
      },
      () => {
        if (this.state.selectedPlug !== null) {
          calculateEstimatedCost(
            30,
            this.props.charger.properties,
            this.state.selectedPlug
          ).then((cost) => this.safeSetState({ costPer30: cost }));
          calculateEstimatedCost(
            this.state.estimateTime,
            this.props.charger.properties,
            this.state.selectedPlug
          ).then((cost) => this.safeSetState({ cost: cost }));
        }
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(this.state.plugs, this.props.charger.properties.plugs)) {
      this.safeSetState(
        {
          plugs: this.props.charger.properties.plugs,
          selectedPlug:
            this.props.charger.properties.plugs.length > 0
              ? this.props.charger.properties.plugs[0]
              : null,
          estimateTime: 30,
        },
        () => {
          if (this.state.selectedPlug !== null) {
            calculateEstimatedCost(
              30,
              this.props.charger.properties,
              this.state.selectedPlug
            ).then((cost) => this.safeSetState({ costPer30: cost }));
            calculateEstimatedCost(
              this.state.estimateTime,
              this.props.charger.properties,
              this.state.selectedPlug
            ).then((cost) => this.safeSetState({ cost: cost }));
          }
        }
      );
    }

    if (this.props.charger?.properties?.source === "MobiE") {
      if (this.state.selectedPlug !== prevState.selectedPlug) {
        this.fetchMobieTariffs();
      }
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  calculateMaxTimeEstimate() {
    if (this.state.selectedPlug !== null) {
      if (this.state.selectedPlug.power <= 7.4) return 1440;
      else if (
        this.state.selectedPlug.power > 7.4 &&
        this.state.selectedPlug.power <= 22
      )
        return 720;
      else if (this.state.selectedPlug.power > 22) return 360;
    }
    return 1440;
  }

  handlePlugClick(e, plug) {
    this.safeSetState(
      {
        selectedPlug: plug,
        estimateTime: 30,
      },
      () => {
        calculateEstimatedCost(
          30,
          this.props.charger.properties,
          this.state.selectedPlug
        ).then((cost) => this.safeSetState({ costPer30: cost }));
        calculateEstimatedCost(
          this.state.estimateTime,
          this.props.charger.properties,
          this.state.selectedPlug
        ).then((cost) => this.safeSetState({ cost }));
        this.calculateMaxTimeEstimate();
      }
    );
  }

  handleSliderChange(estimateTime) {
    this.safeSetState({ estimateTime }, () => {
      if (cancelToken !== null)
        cancelToken.cancel("Cancelled. New request made");
      cancelToken = CancelToken.source();
      calculateEstimatedCost(
        this.state.estimateTime,
        this.props.charger.properties,
        this.state.selectedPlug,
        null,
        cancelToken
      )
        .then((cost) => {
          this.safeSetState({ cost });
        })
        .catch((err) => {
          if (axios.isCancel(err)) console.log("axios", err);
          else console.log(err);
        });
    });
  }

  handleOnCharge(e) {
    axios
      .get("/api/private/contracts", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.length > 0) {
            const post = {
              evId: "-1",
              chargerId: this.props.charger.properties.hwId,
              hwId: this.props.charger.properties.hwId,
              action: "start",
              plugId: this.state.selectedPlug.plugId,
              idTag: res.data[0].cards[0].idTag,
              tariffId: "-1",
            };

            axios
              .post("/api/private/connectionstation", post, {
                cancelToken: new CancelToken((c) => (this.cancel = c)),
              })
              .then((res) => {
                if (res.status === 200) {
                  const sessionId = res.data.sessionId;
                  const animation = lottie.loadAnimation({
                    container: this.elContainer,
                    renderer: "svg",
                    loop: true,
                    autoplay: true,
                    animationData: lottieModule.getAnimation(
                      this.props.charger.properties.chargerType
                    ),
                  });
                  this.safeSetState({ isAnimationRunning: true }, () => {
                    animation.addEventListener("DOMLoaded", () => {
                      var counter = 0;
                      const interval = setInterval(() => {
                        if (counter < 40)
                          axios
                            .get(
                              "/api/private/chargingSession/myActiveSessions"
                            )
                            .then((res) => {
                              if (res.status === 200) {
                                if (Array.isArray(res.data))
                                  if (
                                    res.data.some(
                                      (s) =>
                                        s._id === sessionId &&
                                        parseInt(s.status) === 20
                                    )
                                  ) {
                                    clearInterval(interval);
                                    window.location.assign("../sessions");
                                    animation.stop();
                                  }
                              }
                            })
                            .catch((err) => {
                              if (
                                err.response &&
                                err.response.data &&
                                err.response.data.code
                              )
                                this.props.setAlert(
                                  I18n.t(err.response.data.message),
                                  "danger"
                                );
                              else
                                this.props.setAlert(
                                  I18n.t("general_error"),
                                  "danger"
                                );
                              if (axios.isCancel(err))
                                console.log("axios", err);
                              else console.log(err);
                            })
                            .finally(() => counter++);
                        else {
                          clearInterval(interval);
                          animation.stop();
                          this.props.onHide();
                        }
                      }, 3 * 1000);
                    });
                  });
                }
              })
              .catch((err) => {
                if (err.response && err.response.data && err.response.data.code)
                  this.props.setAlert(
                    I18n.t(err.response.data.message),
                    "danger"
                  );
                else this.props.setAlert(I18n.t("general_error"), "danger");
                if (axios.isCancel(err)) console.log("axios", err);
                else console.log(err);
              });
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.code)
          this.props.setAlert(I18n.t(err.response.data.message), "danger");
        else this.props.setAlert(I18n.t("general_error"), "danger");
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  }

  fetchMobieTariffs() {
    const estimatedTime = this.state.estimateTime / 60;
    const stopDate = moment
      .utc(this.state.date)
      .add(estimatedTime, "hours")
      .format();

    axios
      .get("/api/private/contracts")
      .then((res) => {
        if (res.status === 200) {
          const post = {
            address: {
              city: this.props.charger?.properties?.address?.city,
              street: this.props.charger?.properties?.address?.street,
            },
            countryCode: this.props.charger?.properties?.countryCode,
            elements: this.state.selectedPlug?.serviceCost?.elements,
            latitude: this.props.charger?.geometry?.coordinates[1],
            longitude: this.props.charger?.geometry?.coordinates[0],
            planId: res.data.filter((obj) => obj.contractType === "user")[0]
              .tariff.planId,
            power: this.state.selectedPlug?.power,
            sessionStartDate: moment.utc(this.state.date).format(),
            sessionStopDate: stopDate,
            source: this.props.charger?.properties?.source,
            total_charging_time: roundToDecimals(
              this.state.estimateTime / 60,
              2
            ),
            total_energy:
              this.state.cost === null
                ? roundToDecimals(this.state.costPer30?.consumption, 0)
                : roundToDecimals(this.state.cost?.consumption, 0),
            total_parking_time: 0,
            voltageLevel: this.props.charger?.properties?.voltageLevel,
          };

          axios
            .post("/api/public/ocpi/cpoTariffsPrices", post)
            .then((res) => {
              if (res.status === 200) {
                this.safeSetState({
                  cpoTariffsPrices: res.data,
                });
              }
            })
            .catch((err) =>
              this.props.setAlert(I18n.t(err.response.data.message), "danger")
            );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  handleOnDateChange(e) {
    this.safeSetState({
      date: e.target.value,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <div
          className={
            "picker-cost-container " +
            (this.state.isAnimationRunning ? "blank" : "")
          }
          ref={(el) => (this.elContainer = el)}
        >
          <div id="plugPicker">
            <p>
              <Translate value="chargerPointFullDetails_choosePlug" />
            </p>
            <div className="plugs">
              {this.state.plugs &&
                this.state.plugs.map(
                  (plug, k) =>
                    plug.hasOwnProperty("connectorType") && (
                      <div key={k} className="plug-container">
                        {plug.hasOwnProperty("qrCodeId") &&
                          plug.qrCodeId &&
                          plug.qrCodeId !== "" && (
                            <div className="plug-qrcode">{plug.qrCodeId}</div>
                          )}
                        <div
                          key={
                            this.props.charger.properties.hwId +
                            plug.connectorType +
                            k
                          }
                          className={
                            "plug " +
                            (this.state.selectedPlug !== null &&
                            this.state.selectedPlug.plugId === plug.plugId
                              ? "selected"
                              : "")
                          }
                          onClick={(e) => this.handlePlugClick(e, plug)}
                        >
                          <img
                            src={getPlug(plug.connectorType).plug}
                            alt="connector"
                          />
                          <div className="connector">
                            <p>{plug.connectorType}</p>
                          </div>
                          <div
                            className={
                              "status " +
                              (plug.hasOwnProperty("status") &&
                                getPlugStatus(plug.status))
                            }
                          />
                        </div>
                        <div>
                          {plug.power ? (
                            <p>{plug.power + "kW"}</p>
                          ) : (
                            <p>- kW</p>
                          )}
                        </div>
                        {plug.hasOwnProperty("status") && (
                          <div className="status-string">
                            <Translate
                              value={`chargerDetails_plugStatus_${getPlugStatus(
                                plug.status
                              )}`}
                            />
                          </div>
                        )}
                      </div>
                    )
                )}
            </div>
            <div className="plug-details">
              <div className="price">
                <p>
                  <Translate value="chargerDetails_priceEstimative" />
                </p>
                {this.state.selectedPlug !== null ? (
                  <b>
                    {this.props.charger?.properties?.source === "MobiE"
                      ? this.state.cpoTariffsPrices?.detail?.total?.total
                      : this.state.costPer30
                      ? roundToDecimals(this.state.costPer30.totalCost, 2)
                      : 0}
                    € / 30min
                  </b>
                ) : (
                  <Translate value="chargerPointFullDetails_noPlugSelected" />
                )}
              </div>
            </div>
          </div>
          <hr />
          <div id="costEstimation">
            <p>
              <Translate value="chargerPointFullDetails_estimateCost" />
              <button
                type="button"
                className="clear"
                onClick={() => this.setModal("info", true)}
              >
                <img src={info} alt="" />
              </button>
            </p>
            <div className="date-container">
              <input
                type="datetime-local"
                min={"2023-02-16T08:30"}
                value={this.state.date}
                onChange={(e) => this.handleOnDateChange(e)}
              />
              <input
                type="text"
                value={moment(this.state.date).format("DD-MM-YYYY HH:DD:SS")}
                readOnly
              />
            </div>
            <div className="slider-container">
              <div
                className="filled-track"
                style={{
                  width: `calc(${
                    (this.state.estimateTime - 30) /
                    (this.calculateMaxTimeEstimate() - 30)
                  } * (100% - 30px) +
                  30px)`,
                }}
              />
              <input
                type="range"
                min="30"
                max={this.calculateMaxTimeEstimate()}
                className="slider"
                value={this.state.estimateTime}
                onChange={(e) => {
                  this.safeSetState({
                    estimateTime: e.target.value,
                  });
                }}
                onMouseUp={(e) => {
                  const value = e.target.value;
                  this.handleSliderChange(value);
                  this.props.charger?.properties?.source === "MobiE" &&
                    this.fetchMobieTariffs();
                }}
              />
              <div className="time">
                {this.state.estimateTime >= 60
                  ? Math.trunc(this.state.estimateTime / 60) +
                    "h " +
                    (this.state.estimateTime % 60) +
                    "min"
                  : this.state.estimateTime + "min"}
              </div>
            </div>
            {this.props.charger?.properties?.source === "MobiE" ? (
              <div className="cost-details">
                <div className="total-cost">
                  <p>
                    <Translate value="history_cost" /> (€)
                  </p>
                  {this.state.cpoTariffsPrices?.detail?.total?.total ? (
                    this.state.cpoTariffsPrices?.detail?.total?.total
                  ) : (
                    <Spinner animation="grow" size="sm" />
                  )}
                </div>
                <div className="power">
                  <p>
                    <Translate value="session_simulator_ceme" /> (kWh)
                  </p>
                  {this.state.cost ? (
                    this.state.cost.consumption ? (
                      roundToDecimals(this.state.cost.consumption, 0)
                    ) : (
                      "-"
                    )
                  ) : (
                    <Spinner animation="grow" size="sm" />
                  )}
                </div>
                <div className="price-kwh">
                  <p>
                    € <Translate value="comparator_per_kWh" />
                  </p>
                  {this.state.cpoTariffsPrices?.detail?.total?.totalBykWh ? (
                    this.state.cpoTariffsPrices?.detail?.total?.totalBykWh
                  ) : (
                    <Spinner animation="grow" size="sm" />
                  )}
                </div>
                <div className="price-min">
                  <p>
                    € <Translate value="comparator_per_min" />
                  </p>
                  {this.state.cpoTariffsPrices?.detail?.total?.totalByTime ? (
                    this.state.cpoTariffsPrices?.detail?.total?.totalByTime
                  ) : (
                    <Spinner animation="grow" size="sm" />
                  )}
                </div>
              </div>
            ) : (
              <div className="cost-details">
                <div className="time">
                  <p>
                    <Translate value="chargerPointFullDetails_time" />
                  </p>
                  {this.state.estimateTime >= 60
                    ? Math.trunc(this.state.estimateTime / 60) +
                      "h " +
                      (this.state.estimateTime % 60) +
                      "min"
                    : this.state.estimateTime + "min"}
                </div>
                <div className="power-kwh">
                  <p>
                    <Translate value="chargerPointFullDetails_kWh" />
                  </p>
                  {this.state.cost ? (
                    this.state.cost.consumption ? (
                      roundToDecimals(this.state.cost.consumption, 2)
                    ) : (
                      "-"
                    )
                  ) : (
                    <Spinner animation="grow" size="sm" />
                  )}
                </div>
                <div className="price">
                  <p>
                    <Translate value="chargerPointFullDetails_price" />
                  </p>
                  {this.state.cost ? (
                    roundToDecimals(this.state.cost.totalCost, 2) + "€"
                  ) : (
                    <Spinner animation="grow" size="sm" />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {this.state.selectedPlug !== null && (
          <CostInfoModal
            show={this.state.modals.info}
            onHide={() => this.setModal("info", false)}
            mode={getModeByChargerType(
              this.props.charger.properties.chargerType
            )}
            cost={this.state.cost}
            charger={this.props.charger}
            cpoTariffsPrices={this.state.cpoTariffsPrices}
            estimateTime={this.state.estimateTime}
            selectedPlug={this.state.selectedPlug}
            date={this.state.date}
          />
        )}
      </>
    );
  }
}

export default connect(null, { setAlert })(PlugPicker);
